import React, { forwardRef } from 'react';

import { Icon20ShoppingCartOutline } from '@vkontakte/icons';
import { Spacing } from '@vkontakte/vkui';
import { AnimatePresence, motion } from 'framer-motion';

import { PaymentLayoutPropsType } from './types';
import { IconedText } from '../../../../../../../components/IconedText';
import { FRIEND_PREDICTION_PRICE } from '../../../../../../../constants/Common';

export const PaymentLayout = forwardRef<HTMLDivElement, PaymentLayoutPropsType>(({
  children,
  delayAnimation = 0,
  needBuyingDescription = true,
  style
}, ref) => {
  return (
    <div style={{ ...style, paddingTop: '16px' }} ref={ref} >
      <div style={{ paddingBottom: 15, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <AnimatePresence>
          <motion.div
            style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            animate={{ scale: [0.9, 1.06, 1] }}
            transition={{
              duration: 0.6,
              delay: delayAnimation
            }}
          >
            <img style={{ width: '45%' }} src='https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/header_mobile.png' alt=''/>
          </motion.div>
        </AnimatePresence>
      </div>

      {children}
      {needBuyingDescription && (
        <div style={{ margin: '0 16px' }}>
          <IconedText
            icon={
              <AnimatePresence>
                <motion.div
                  animate={{ x: [10, -8, 0] }}
                  transition={{
                    duration: 0.6,
                    delay: delayAnimation
                  }}
                >
                  <Icon20ShoppingCartOutline color="#99A2AD"/>
                </motion.div>
              </AnimatePresence>
            }
            text={`Проверка другого человека становится доступна после оплаты ${FRIEND_PREDICTION_PRICE} голоса. В случае ошибки оплата голосов не будет произведена`}
          />
        </div>
      )}

      <Spacing size={24} />

    </div>
  );
});
